import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useState } from "react";
import EditPlanAttributeApi from "../../../api/attributes/EditPlanAttributeApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function EditPlanAttributeModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    setValuesChanged(false);
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditPlanAttributeApi(
      props.planAttribute?.id,
      value.name
    );
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess(
        "bottomRight",
        "Plan attribute edited successfully"
      );
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit plan attribute. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Edit attribute name"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="planGroup"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        initialValues={{
          name: props.planAttribute?.name,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Attribute name*" name="name">
          <Input placeholder="name" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditPlanAttributeModal;
